<mat-form-field [style.width]="width" floatLabel="always">
  <mat-label>{{ label }}</mat-label>
  <mat-select class="unit-select" [formControl]="formControl" [required]="required" *ngIf="!readonly" (selectionChange)="selectionChange.emit($event)">
    <mat-option>&mdash; Select Unit &mdash;</mat-option>
    <mat-option *ngFor="let unit of units" [value]="unit?.id" [matTooltip]="unit?.longName" matTooltipPosition="right"
      >{{ unit?.shortName }}
    </mat-option>
  </mat-select>
  <input *ngIf="readonly" matInput [value]="selectedUnit?.shortName" [disabled]="formControl.disabled" readonly [required]="required" [matTooltip]="selectedUnit?.longName"/>
  <span matPrefix *ngIf="leftPadding">&nbsp;</span>
  <mat-error *ngIf="formControl.hasError('required')">A unit selection is required</mat-error>
</mat-form-field>
